export enum CollegeSlug {
    CHRYSM = "chrysm",
    NAU = "nau",
    HHS = "hhs",
    Northstar = "northstar",
    Ogleschool = "ogleschool",
    Demo = "demo",
    COLLECTIV = "collectiv",
    COLLECTIVRIMA = "collectivrima",
    ROBERTFIANCE = "robertfiance"
}
